import { render } from "./AkadResepsiSection.vue?vue&type=template&id=43593c20&scoped=true"
import script from "./AkadResepsiSection.vue?vue&type=script&lang=js"
export * from "./AkadResepsiSection.vue?vue&type=script&lang=js"

import "./AkadResepsiSection.vue?vue&type=style&index=0&id=43593c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43593c20"]])

export default __exports__